import { CommonModule } from '@angular/common';
import {
  Component, OnInit, Inject,
  ViewChild, ElementRef, ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } 
    from '@angular/material/dialog';

import { Idle } from '@ng-idle/core';

interface IdleTimeoutData 
{
    idleObj: Idle;
    timeout: number;
}

@Component
({
    selector: 'idle-timeout-modal',
    templateUrl: './idleTimeout.component.html',
    styleUrls: ['./idleTimeout.component.scss'],
    imports: [
        CommonModule,
        MatDialogModule],  // Import child component
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true          // Standalone            
})

export class IdleTimeoutComponent implements OnInit 
{
    private idle: Idle;
    private cdr: ChangeDetectorRef;
    public countdown: number;
    
    //Need this in order to close the dialog box on idle end. 
    // This is because, for some reason,
    //I cannot do a this.dialogRef.close() in the onIdleEnd subscription.
    @ViewChild('closeMeDiv') closeMeDiv: ElementRef;
    
    constructor
    (
        //Data is: {"idleObj":<idle object>, 
        //"timeout":<timeoutPeriodSec (integer)>}
        @Inject(MAT_DIALOG_DATA) public data: IdleTimeoutData,
        public dialogRef: MatDialogRef<IdleTimeoutComponent>,
        cdr: ChangeDetectorRef
    ) 
    { 
        this.idle = data.idleObj;
        this.cdr = cdr;
        this.countdown = data.timeout;
    }
    
    ngOnInit() 
    { 
        this.idle.onTimeoutWarning.subscribe((countdown: number) => 
        {
            // Defer so countdown does not flip mid change-detection
            // (NG0100 when dialog opens during timeout warning).
            Promise.resolve().then(() =>
            {
                this.countdown = countdown;
                this.cdr.markForCheck();
            });
        });
        this.idle.onIdleEnd.subscribe(() =>
        { 
            this.closeMeDiv.nativeElement.click();
        });
    }
    
    closeMe() 
    {
        this.dialogRef.close();
    }
}